import { DOTS, usePaginate } from "./utils/usePaginate";
import "./index.scss";

export const Pagination = ({
  onPageChange,
  pageSize,
  currentPage,
  totalCount,
  siblingCount = 1,
  className = ""
}) => {
  const paginationRange = usePaginate({
    currentPage,
    totalCount: totalCount,
    siblingCount,
    pageSize
  });

  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  const lastPage = paginationRange[paginationRange.length - 1];

  return (
    <ul className={`pagination-container ${className}`}>
      <li
        className={`pagination-item pagination-arrow ${
          currentPage === 1 ? "disabled" : ""
        }`}
        onClick={onPrevious}
        data-testid="previous-page"
      >
        &#10094;
      </li>
      {paginationRange.map((pageNumber, index) => {
        if (pageNumber === DOTS) {
          return (
            <li
              className="pagination-item dots"
              key={`${pageNumber}-${index}`}
              data-testid="dots"
            >
              &#8230;
            </li>
          );
        }

        return (
          <li
            className={`pagination-item ${
              pageNumber === currentPage ? "selected" : ""
            }`}
            key={pageNumber}
            onClick={() => onPageChange(pageNumber)}
            data-testid="page-item"
          >
            {pageNumber}
          </li>
        );
      })}
      <li
        className={`pagination-item pagination-arrow ${
          currentPage === lastPage ? "disabled" : ""
        }`}
        onClick={onNext}
        data-testid="next-page"
      >
        &#10095;
      </li>
    </ul>
  );
};
